<div fxLayout="column" class="db-wrapper">
    <div fxLayout="row" class="section-heading">
        <h6>Database update</h6>
    </div>
    <div class="db-update-item-wrapper" fxLayout="column" fxLayoutAlign="start stretch">
        <div fxFlex *ngFor="let item of dbupdatesToShow">
            <div class="db-update-item">
                <div class="update-date">
                    {{ ( item.creationDate | date : 'dd MMMM yyyy  hh:mm') || '' }}
                    <div *ngIf="item.title && item.title !== '.'" class="text-truncate w-100">{{ item.title || '' }}</div>
                </div>
                <div class="update-content"><div class="content" [innerHTML]="item.content"></div></div>
            </div>
        </div>
    </div>
</div>
<div fxLayout="row" class="load-all-wrapper" fxLayoutAlign="center center">
    <a fxLayout="row" fxLayoutAlign="center center" (click)="loadAll()" class="load-all" *ngIf="!loadedAll">Load older posts</a>
</div>
